

































import { defineComponent, computed } from '@vue/composition-api';
import { Identicon, LockLockedIcon, CircleSpinner } from '@nimiq/vue-components';
import Amount from './Amount.vue';
import FiatConvertedAmount from './FiatConvertedAmount.vue';
import VestingIcon from './icons/VestingIcon.vue';
import { AddressInfo, AddressType } from '../stores/Address';
import { useStakingStore } from '../stores/Staking';
import { CryptoCurrency } from '../lib/Constants';
import BitcoinIcon from './icons/BitcoinIcon.vue';
import UsdcIcon from './icons/UsdcIcon.vue';
import UsdtIcon from './icons/UsdtIcon.vue';
import TwoLeafStakingIcon from './icons/Staking/TwoLeafStakingIcon.vue';

export default defineComponent({
    props: {
        embedded: {
            type: Boolean,
            default: false,
        },
        addressInfo: {
            type: Object as () => AddressInfo |
                Pick<AddressInfo, 'address' | 'label' | 'balance'> & {
                    type: CryptoCurrency.BTC | CryptoCurrency.USDC | CryptoCurrency.USDT,
                },
            required: true,
        },
    },
    setup(props) {
        const currentCurrency = computed(() => {
            switch (props.addressInfo.type) {
                case CryptoCurrency.BTC: return CryptoCurrency.BTC;
                case CryptoCurrency.USDC: return CryptoCurrency.USDC;
                case CryptoCurrency.USDT: return CryptoCurrency.USDT;
                default: return CryptoCurrency.NIM;
            }
        });

        const { totalStakesByAddress } = useStakingStore();
        const totalStake = computed(() => totalStakesByAddress.value[props.addressInfo.address] || 0);

        return {
            AddressType,
            CryptoCurrency,
            currentCurrency,
            totalStake,
        };
    },
    components: {
        Identicon,
        LockLockedIcon,
        Amount,
        FiatConvertedAmount,
        VestingIcon,
        BitcoinIcon,
        UsdcIcon,
        UsdtIcon,
        TwoLeafStakingIcon,
        CircleSpinner,
    },
});
